import { Navigate, Outlet, useSearchParams } from 'react-router-dom';

import { useCurrentTenantQuery } from '@/modules/companies/queries/useCurrentTenantQuery';
import { toSearchSuffix } from '@/modules/hiring-manager/utils/searchSuffix';
import Loader from '@/modules/ui/components/loader/Loader';

/**
 * Interviews and Availability belong to the coordination agent. Without a
 * coordination-enabled job they would stay empty, since meetings booked
 * outside Finlay are not synced, so direct links go back to jobs.
 */
export function CoordinationRoute() {
  const currentTenantQuery = useCurrentTenantQuery();
  const [searchParams] = useSearchParams();

  if (currentTenantQuery.isLoading) return <Loader />;
  if (currentTenantQuery.data?.hasCoordinationEnabledJobs !== true) {
    return <Navigate replace to={`/hm${toSearchSuffix(searchParams)}`} />;
  }
  return <Outlet />;
}
